/** @typedef {import('./Props').default} Props */

import { withSubscriptionService } from '../../../../../service-container';
import React from 'react';
import SubscriptionPlans from '../../../../../shared/SubscriptionCheckout/SubscriptionPlans/SubscriptionPlans';
import tiers from '../../../../Agent/Subscription/Checkout/subscriptionTiersData';
import useGetGroupCheckoutLinks from '../../../../../Hooks/Admin/Getters/useGetGroupCheckoutLinks/useGetGroupCheckoutLinks';
import useGetAgentSubscription from '../../../../../Hooks/Agent/Getters/useGetAgentSubscription/useGetAgentSubscription';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export function Checkout(props) {
	const checkoutLinks = useGetGroupCheckoutLinks(props.groupId);
	const subscriptionData = useGetAgentSubscription();

	return (
		<section className="pt-6">
			<SubscriptionPlans
				checkoutRole="manager"
				isGettingData={checkoutLinks.isGettingData}
				paymentLinks={checkoutLinks.data}
				subscription={subscriptionData.data}
				tiers={tiers}
			/>
		</section>
	);
}

export default withSubscriptionService(Checkout);
